import { useTranslation } from 'react-i18next'

// What a rally calls for. Styled like UnRecommendations.tsx.
export function RallyDemands({ titleKey, itemKeys }: { titleKey: string; itemKeys: string[] }) {
  const { t } = useTranslation()
  return (
    <section
      aria-labelledby='rally-demands-heading'
      className='flex flex-col gap-8 md:gap-12 px-6 py-25 bg-gray-50 text-center text-md md:text-xl leading-relaxed opacity-90'
    >
      <h3 id='rally-demands-heading' className='text-4xl md:text-5xl font-medium'>
        {t(titleKey)}
      </h3>
      <ul className='list-disc list-inside max-w-4xl mx-auto'>
        {itemKeys.map((key) => (
          <li key={key} className='mb-2 text-2xl leading-relaxed'>
            {t(key)}
          </li>
        ))}
      </ul>
    </section>
  )
}
